/* eslint-disable func-names */
import EDC from '../../../shared/globals';

/**
 *
 */
EDC.Animations.Castle = function (scene) {
  this.scene = scene;
  this.castleSprite = null;
  this.totalFlyTime = 8000;
  this.flyOffset = 35;
};
/**
 *
 */
EDC.Animations.Castle.prototype.create = function () {
  this.castleSprite = this.scene.add.sprite(300, 300, 'castle');
};
/**
 *
 */
EDC.Animations.Castle.prototype.place = function (x, y) {
  this.castleSprite.setPosition(x, y);
};
/**
 *
 */
EDC.Animations.Castle.prototype.getBounds = function () {
  return this.castleSprite.getBounds();
};
/**
 *
 */
EDC.Animations.Castle.prototype.startFlying = function () {
  this.scene.tweens.add({
    targets: this.castleSprite,
    x: this.castleSprite.x + this.flyOffset,
    duration: this.totalFlyTime,
    ease: 'Sine.easeInOut',
    yoyo: true,
    repeat: -1,
  });
};

export default EDC.Animations.Castle;
